/* eslint-disable */
import React from 'react';
import { useWidget } from './useWidgetHook';
import { Container } from '@material-ui/core';
import AppRouter from 'routes';
import WidgetHeader from '../WidgetHeader';
import { useStyles } from './styles';
import { Switch } from 'react-router-dom';

export default function Root(props) {
  const classes = useStyles();
  useWidget();

  return (
    <Switch>
      <Container
        className={classes.root}
        data-testid={props['data-testid']}
        maxWidth="sm"
        disableGutters
      >
        <WidgetHeader />
        <main className="container__main">
          <AppRouter />
        </main>
      </Container>
    </Switch>
  );
}
